'use strict';

(function () {
  'use strict';

  angular.module('youth').config(['$stateProvider', 'errorRouterProvider', function ($stateProvider, errorRouterProvider) {
    var errorRoutes = errorRouterProvider.buildRoutes();
    //wire the routes
    for (var index in errorRoutes) {
      if (errorRoutes.hasOwnProperty(index)) {
        var route = errorRoutes[index];
        if (route.hasOwnProperty('name')) {
          $stateProvider.state(route.name, route);
        }
      }
    }
  }]);
})();